export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const dateRegex = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

export const realNumRegex = /(^([0]|([1-9]\d*))([,]\d{0,2}){0,1}$)|(^$)/;

export const paymentNumRegex = /^[a-zA-Z0-9а-яА-ЯёЁ\-]*$/;

// export const paymentNumRegex = /[\w\d-]/;
